export default __webpack_public_path__ + "static/media/kitchen001.b294d01f.jpeg";